import React from 'react'
import { styles } from './amp.styles'
import { imageUrl } from '@libs/appUrl'

export function UserInfo(props) {
  return (
    <div className="userInfo">
      <style jsx>{styles}</style>
      <a href={props.href}>
        <amp-img
          className="userInfo__img"
          src={imageUrl(props.img || '/img/head2.png')}
          width="1"
          height="1"
          layout="responsive"
          alt={props.name}
        />
      </a>
      <div className="userInfo__block">
        <a className="userInfo__name" href={props.href}>
          {props.name}
        </a>
        {props.loc && props.locName && (
          <a className="userInfo__des" href={`/${props.loc.replace(/\./g, '/')}`}>
            {props.locName}
          </a>
        )}
        {props.description && (
          <a href={props.href} className="userInfo__des">
            {props.description}
          </a>
        )}
      </div>
    </div>
  )
}

export default UserInfo
